/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
export type AssetPageFragment = {
	__typename?: "AssetConnection";
	pageInfo?: {
		__typename?: "PageInfo";
		hasNextPage: boolean;
		hasPreviousPage: boolean;
		startCursor?: string | null;
		endCursor?: string | null;
	} | null;
	edges?: Array<{
		__typename?: "AssetEdge";
		cursor?: string | null;
		node?:
			| { __typename?: "CommodityAsset" }
			| {
					__typename?: "CryptoAsset";
					marketCap?: { value: string; precision: number } | null;
					id: string;
					pid: string;
					symbol: string;
					name: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					staking?: { __typename?: "Staking"; estimatedRewards: { value: string; precision: number } } | null;
					marginLongSettings?: {
						__typename?: "AssetMarginSettings";
						maximumLeverage?: number | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						automatedOrderEnabled?: boolean | null;
					} | null;
					ohlc?: Array<{
						__typename?: "OhlcData";
						open?: { value: string; precision: number } | null;
						high?: { value: string; precision: number } | null;
						close?: { value: string; precision: number } | null;
						low?: { value: string; precision: number } | null;
						time?: any | null;
					}> | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						theme?: Types.UiTheme | null;
						url: string;
						width: number;
					}>;
			  }
			| { __typename?: "EquityComplexEtfAsset" }
			| { __typename?: "EquityEtcAsset" }
			| { __typename?: "EquityEtfAsset" }
			| { __typename?: "EquityRightAsset" }
			| { __typename?: "EquityStockAsset" }
			| { __typename?: "EtfAsset" }
			| { __typename?: "GenericAsset" }
			| { __typename?: "IndexAsset" }
			| { __typename?: "LeverageAsset" }
			| { __typename?: "MetalAsset" }
			| { __typename?: "SecurityTokenAsset" }
			| { __typename?: "StockAsset" }
			| null;
	} | null> | null;
	facets?: Array<
		| { __typename?: "AssetCategoryFacet" }
		| {
				__typename?: "MarginMaximumLeverageFacet";
				field?: string | null;
				values?: Array<{
					__typename?: "MarginMaximumLeverageFacetValue";
					key: string;
					count?: number | null;
					value: number;
				}> | null;
		  }
		| { __typename?: "TransactionFacet" }
	> | null;
};

export type GenericAsset_CommodityAsset_Fragment = {
	__typename?: "CommodityAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_CryptoAsset_Fragment = {
	__typename?: "CryptoAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_EquityComplexEtfAsset_Fragment = {
	__typename?: "EquityComplexEtfAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_EquityEtcAsset_Fragment = {
	__typename?: "EquityEtcAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	metrics?: { __typename?: "EtpAssetMetrics"; isin: string } | null;
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_EquityEtfAsset_Fragment = {
	__typename?: "EquityEtfAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	metrics?: { __typename?: "EtpAssetMetrics"; isin: string } | null;
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_EquityRightAsset_Fragment = {
	__typename?: "EquityRightAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_EquityStockAsset_Fragment = {
	__typename?: "EquityStockAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	metrics?: { __typename?: "StockAssetMetrics"; isin: string } | null;
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_EtfAsset_Fragment = {
	__typename?: "EtfAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_GenericAsset_Fragment = {
	__typename?: "GenericAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_IndexAsset_Fragment = {
	__typename?: "IndexAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_LeverageAsset_Fragment = {
	__typename?: "LeverageAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_MetalAsset_Fragment = {
	__typename?: "MetalAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_SecurityTokenAsset_Fragment = {
	__typename?: "SecurityTokenAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAsset_StockAsset_Fragment = {
	__typename?: "StockAsset";
	id: string;
	idInternal: number;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type GenericAssetFragment =
	| GenericAsset_CommodityAsset_Fragment
	| GenericAsset_CryptoAsset_Fragment
	| GenericAsset_EquityComplexEtfAsset_Fragment
	| GenericAsset_EquityEtcAsset_Fragment
	| GenericAsset_EquityEtfAsset_Fragment
	| GenericAsset_EquityRightAsset_Fragment
	| GenericAsset_EquityStockAsset_Fragment
	| GenericAsset_EtfAsset_Fragment
	| GenericAsset_GenericAsset_Fragment
	| GenericAsset_IndexAsset_Fragment
	| GenericAsset_LeverageAsset_Fragment
	| GenericAsset_MetalAsset_Fragment
	| GenericAsset_SecurityTokenAsset_Fragment
	| GenericAsset_StockAsset_Fragment;

export type AssetFragment = {
	__typename?: "CryptoAsset";
	marketCap?: { value: string; precision: number } | null;
	id: string;
	pid: string;
	symbol: string;
	name: string;
	price: { value: string; precision: number };
	priceChange: { value: string; percentage: number };
	staking?: { __typename?: "Staking"; estimatedRewards: { value: string; precision: number } } | null;
	marginLongSettings?: {
		__typename?: "AssetMarginSettings";
		maximumLeverage?: number | null;
		buyActive?: boolean | null;
		sellActive?: boolean | null;
		automatedOrderEnabled?: boolean | null;
	} | null;
	ohlc?: Array<{
		__typename?: "OhlcData";
		open?: { value: string; precision: number } | null;
		high?: { value: string; precision: number } | null;
		close?: { value: string; precision: number } | null;
		low?: { value: string; precision: number } | null;
		time?: any | null;
	}> | null;
	logos: Array<{
		__typename?: "Image";
		height: number;
		mimeType: string;
		theme?: Types.UiTheme | null;
		url: string;
		width: number;
	}>;
};

export type MarginMaximumLeverageFacetFragment = {
	__typename?: "MarginMaximumLeverageFacet";
	field?: string | null;
	values?: Array<{
		__typename?: "MarginMaximumLeverageFacetValue";
		key: string;
		count?: number | null;
		value: number;
	}> | null;
};

export type MarginMaximumLeverageFacetValueFragment = {
	__typename?: "MarginMaximumLeverageFacetValue";
	key: string;
	count?: number | null;
	value: number;
};

export type PortfolioMarginPositionsPageFragment = {
	__typename?: "PortfolioMarginPositionsConnection";
	pageInfo?: {
		__typename?: "PageInfo";
		hasNextPage: boolean;
		hasPreviousPage: boolean;
		startCursor?: string | null;
		endCursor?: string | null;
	} | null;
	edges?: Array<{
		__typename?: "MarginPositionEdge";
		cursor?: string | null;
		node?: {
			__typename?: "MarginPosition";
			id: string;
			assetPosition: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
			fiatPosition: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
			leverage: { value: string; precision: number };
			leverageDirection: Types.LeverageDirection;
			performancePercentage: { value: string; precision: number };
			performance: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
			liquidationPrice: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
			liquidationThresholdPercentage: { value: string; precision: number };
			availableLimitOrderExitOrderTypes?: Array<Types.MarginLimitOrderExitOrderType> | null;
			initialInvestment?: {
				precision: number;
				unit_symbol: string;
				unit_symbol_type: string;
				value: string;
			} | null;
			borrowedFunds?: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string } | null;
			averageOpeningPrice?: {
				precision: number;
				unit_symbol: string;
				unit_symbol_type: string;
				value: string;
			} | null;
			limitOrders?: Array<{
				__typename?: "MarginLimitOrder";
				id: string;
				pid: string;
				assetAmount: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
				exitOrderType: Types.MarginLimitOrderExitOrderType;
				targetPrice: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
				targetPriceChangePercentage: { value: string; precision: number };
			}> | null;
			marginLevel: {
				__typename?: "MarginLevel";
				current: { value: string; precision: number };
				healthIndicator: Types.MarginHealthIndicator;
				maximum: { value: string; precision: number };
				minimum: { value: string; precision: number };
				highHealthThreshold: { value: string; precision: number };
				lowHealthThreshold: { value: string; precision: number };
			};
			asset:
				| {
						__typename?: "CommodityAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "CryptoAsset";
						marketCap?: { value: string; precision: number } | null;
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityComplexEtfAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityEtcAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityEtfAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityRightAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EquityStockAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "EtfAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "GenericAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "IndexAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "LeverageAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "MetalAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "SecurityTokenAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  }
				| {
						__typename?: "StockAsset";
						id: string;
						pid: string;
						symbol: string;
						name: string;
						price: { value: string; precision: number };
						priceChange: { value: string; percentage: number };
						inWatchlist: boolean;
						maintenanceEnabled?: boolean | null;
						available?: boolean | null;
						buyActive?: boolean | null;
						sellActive?: boolean | null;
						transferActive?: boolean | null;
						withdrawActive?: boolean | null;
						depositActive?: boolean | null;
						logos: Array<{
							__typename?: "Image";
							url: string;
							mimeType: string;
							width: number;
							height: number;
							theme?: Types.UiTheme | null;
						}>;
						ohlc?: Array<{
							__typename?: "OhlcData";
							open?: { value: string; precision: number } | null;
							high?: { value: string; precision: number } | null;
							close?: { value: string; precision: number } | null;
							low?: { value: string; precision: number } | null;
							time?: any | null;
						}> | null;
				  };
		} | null;
	}> | null;
};

export type MarginPositionFragment = {
	__typename?: "MarginPosition";
	id: string;
	assetPosition: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
	fiatPosition: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
	leverage: { value: string; precision: number };
	leverageDirection: Types.LeverageDirection;
	performancePercentage: { value: string; precision: number };
	performance: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
	liquidationPrice: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
	liquidationThresholdPercentage: { value: string; precision: number };
	availableLimitOrderExitOrderTypes?: Array<Types.MarginLimitOrderExitOrderType> | null;
	initialInvestment?: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string } | null;
	borrowedFunds?: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string } | null;
	averageOpeningPrice?: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string } | null;
	limitOrders?: Array<{
		__typename?: "MarginLimitOrder";
		id: string;
		pid: string;
		assetAmount: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
		exitOrderType: Types.MarginLimitOrderExitOrderType;
		targetPrice: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
		targetPriceChangePercentage: { value: string; precision: number };
	}> | null;
	marginLevel: {
		__typename?: "MarginLevel";
		current: { value: string; precision: number };
		healthIndicator: Types.MarginHealthIndicator;
		maximum: { value: string; precision: number };
		minimum: { value: string; precision: number };
		highHealthThreshold: { value: string; precision: number };
		lowHealthThreshold: { value: string; precision: number };
	};
	asset:
		| {
				__typename?: "CommodityAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "CryptoAsset";
				marketCap?: { value: string; precision: number } | null;
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "EquityComplexEtfAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "EquityEtcAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "EquityEtfAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "EquityRightAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "EquityStockAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "EtfAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "GenericAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "IndexAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "LeverageAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "MetalAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "SecurityTokenAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  }
		| {
				__typename?: "StockAsset";
				id: string;
				pid: string;
				symbol: string;
				name: string;
				price: { value: string; precision: number };
				priceChange: { value: string; percentage: number };
				inWatchlist: boolean;
				maintenanceEnabled?: boolean | null;
				available?: boolean | null;
				buyActive?: boolean | null;
				sellActive?: boolean | null;
				transferActive?: boolean | null;
				withdrawActive?: boolean | null;
				depositActive?: boolean | null;
				logos: Array<{
					__typename?: "Image";
					url: string;
					mimeType: string;
					width: number;
					height: number;
					theme?: Types.UiTheme | null;
				}>;
				ohlc?: Array<{
					__typename?: "OhlcData";
					open?: { value: string; precision: number } | null;
					high?: { value: string; precision: number } | null;
					close?: { value: string; precision: number } | null;
					low?: { value: string; precision: number } | null;
					time?: any | null;
				}> | null;
		  };
};

export type PageInfoFragment = {
	__typename?: "PageInfo";
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	startCursor?: string | null;
	endCursor?: string | null;
};

export const PageInfoFragmentDoc = gql`
	fragment PageInfo on PageInfo {
		hasNextPage
		hasPreviousPage
		startCursor
		endCursor
	}
`;
export const AssetFragmentDoc = gql`
	fragment Asset on CryptoAsset {
		id
		pid
		symbol
		name
		price
		priceChange(period: $period)
		ohlc(period: $period) @include(if: $includeOHLC) {
			open
			high
			close
			low
			time
		}
		marginLongSettings {
			automatedOrderEnabled
		}
		... on CryptoAsset {
			marketCap
			staking {
				estimatedRewards
			}
			marginLongSettings {
				maximumLeverage
				buyActive
				sellActive
			}
		}
		logos {
			height
			mimeType
			theme
			url
			width
		}
	}
`;
export const MarginMaximumLeverageFacetValueFragmentDoc = gql`
	fragment MarginMaximumLeverageFacetValue on MarginMaximumLeverageFacetValue {
		key
		count
		value
	}
`;
export const MarginMaximumLeverageFacetFragmentDoc = gql`
	fragment MarginMaximumLeverageFacet on MarginMaximumLeverageFacet {
		field
		values {
			...MarginMaximumLeverageFacetValue
		}
	}
	${MarginMaximumLeverageFacetValueFragmentDoc}
`;
export const AssetPageFragmentDoc = gql`
	fragment AssetPage on AssetConnection {
		pageInfo {
			...PageInfo
		}
		edges {
			cursor
			node {
				...Asset
			}
		}
		facets {
			... on MarginMaximumLeverageFacet @include(if: $includeMaximumLeverage) {
				...MarginMaximumLeverageFacet
			}
		}
	}
	${PageInfoFragmentDoc}
	${AssetFragmentDoc}
	${MarginMaximumLeverageFacetFragmentDoc}
`;
export const GenericAssetFragmentDoc = gql`
	fragment GenericAsset on Asset {
		id
		idInternal
		pid
		symbol
		name
		price
		logos {
			height
			mimeType
			theme
			url
			width
		}
		... on EquityStockAsset {
			metrics {
				isin
			}
		}
		... on EquityEtfAsset {
			metrics {
				isin
			}
		}
		... on EquityEtcAsset {
			metrics {
				isin
			}
		}
	}
`;
export const MarginPositionFragmentDoc = gql`
	fragment MarginPosition on MarginPosition {
		id
		assetPosition
		fiatPosition
		leverage
		leverageDirection
		performancePercentage
		performance
		liquidationPrice
		liquidationThresholdPercentage
		limitOrders {
			id
			pid
			assetAmount
			exitOrderType
			targetPrice
			targetPriceChangePercentage
		}
		availableLimitOrderExitOrderTypes
		initialInvestment
		borrowedFunds
		marginLevel {
			current
			healthIndicator
			maximum
			minimum
			highHealthThreshold
			lowHealthThreshold
		}
		averageOpeningPrice
		asset {
			id
			pid
			symbol
			name
			logos {
				url
				mimeType
				width
				height
				theme
			}
			price
			priceChange(period: $period)
			ohlc(period: $period) {
				open
				high
				close
				low
				time
			}
			inWatchlist
			maintenanceEnabled
			available
			buyActive
			sellActive
			transferActive
			withdrawActive
			depositActive
			... on CryptoAsset {
				marketCap
			}
		}
	}
`;
export const PortfolioMarginPositionsPageFragmentDoc = gql`
	fragment PortfolioMarginPositionsPage on PortfolioMarginPositionsConnection {
		pageInfo {
			...PageInfo
		}
		edges {
			cursor
			node {
				...MarginPosition
			}
		}
	}
	${PageInfoFragmentDoc}
	${MarginPositionFragmentDoc}
`;
